<template>
  <div
    class="setting-popup"
    v-show='boxData.judgeBox'
    :style="{
      'top': boxData.fix.y+'px',
      'left': boxData.fix.x+'px',
      'z-index': boxData.Zindex,
    }"
    @mousedown.stop.prevent="$bus.emit('windowMousedown_vue');isShowZoomScaleMenu=false"
  >
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      变焦
    </div>
    <div class="setting-popup__content">

      <template v-if="SelectScenes_Msg.background && SelectScenes_Msg.background.data.type !== 'Color'">
        <div
          class="setting-popup__item item"
          style="display: block"
        >
          <div class="item__content">
            <div class="row">
              <div class="sub-title">
                焦距
              </div>
              <div class="sub-content">
                <div class="dropdown">
                  <el-popover
                    v-model="isShowZoomScaleMenu"
                    popper-class="stroke-width-dropdown"
                    placement="bottom"
                    width="148"
                    trigger="manual"
                  >
                    <div
                      class="dropdown__select" slot="reference" @mousedown.stop
                      @click="toggleZoomMenu()"
                    >
                      <span>
                        {{getZoomText(zoomActiveOption)}}
                      </span>
                      <i class="icon-dropdown-arrow" :style="{transform: isShowZoomScaleMenu ? `rotate(180deg)` : '', transitionDuration: '0.3s'}"></i>
                    </div>

                    <div class="dropdown__options">
                      <div
                        class="dropdown__item"
                        v-for="(item, i) in zoomScales"
                        :key="i"
                        :class="{active: item.active}"
                        @click="setZoomScale(item, true)"
                        @mousedown.stop
                      >
                        <span>{{getZoomText(item)}}</span>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="row" v-show="zoomActiveOption.num !== 1">
              <div class="sub-title">
                变焦时间
              </div>
              <div class="sub-content">
                <slider-option
                  v-if="boxData.judgeBox"
                  :maxVal="Math.round(SelectScenes_Msg.duration / 1000)"
                  :minVal="0"
                  :step="0.5"
                  :numFixed="1"
                  :numberUnit="'s'"
                  :hasInput="true"
                  :runway-size="72"
                  ref="sliderRef"
                  @updateValue="setZoomDuration"
                ></slider-option>
              </div>
            </div>
          </div>
        </div>
      </template>

    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup"></div>
  </div>
</template>

<script>
import baseBg from '../baseBg.vue'

export default {
  mixins: [baseBg],
  data () {
    return {
      popupType: 'zoomSetting.bg',
      isShowZoomScaleMenu: false
    }
  },
  watch: {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/_colors.scss";
  .setting-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 258px;
    max-height: 562px;
    z-index: 35;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0 0 3px 1px #d8dee9;
    color: #474261;

    &__drag-area {
      line-height: 28px;
      background: #d8dee9;
      text-align: left;
      text-indent: 14px;
    }

    &__close {
      position: absolute;
      top: 7px;
      right: 12px;
      height: 14px;
      line-height: 14px;
      width: 14px;
      cursor: pointer;
    }

    &__content {
      padding: 14px 0;
    }
  }

  .ranges {
    padding: 0 20px;
  }

  .range {
    margin-top: 12px;
    &:first-of-type {
      margin-top: 0;
    }
    &:last-of-type {
      margin-bottom: 20px;
    }
    &__name {
      text-align: left;
      margin-bottom: 12px;
    }
    &__content {
      display: flex;
    }
    &__indicator {
      margin-left: 1em;
    }
  }

  .slider {
    height: 16px;
    // padding-left: 8px;
    &__runway {
      position: relative;
      width: 170px;
      height: 4px;
      border-radius: 4px;
      background-color: $c13;
      margin: 6px 0;
    }
    &__bar {
      height: 4px;
      border-radius: 4px;
      background-color: $c12;
    }
    &__button {
      position: absolute;
      top: -6px;
      margin-left: -8px;
      width: 16px;
      height: 16px;
      border-radius: 16px;
      background-color: $c12;
      cursor: grab;
    }
  }

  .setting-popup__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;
  }
  .item {
    &__title {
      margin-right: 2em;
      margin-bottom: 12px;
      margin-top: 12px;
      text-align: left;
    }
    &__btn {
      width: 80px;
      height: 36px;
      line-height: 36px;
      background-color: #f0f0f8;
      border-radius: 4px;
      border: solid 1px #d8d8e9;
      &:hover {
        cursor: pointer;
        background-color: #d8d8e9;
      }

      &.wide {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;

        & > span {
          margin-left: 10px;
        }
        &:nth-child(2) {
          margin-left: 12px;
        }
      }
    }
  }

  .item__content {
    & .row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 12px;
    }
    & .space {
      width: 218px;
      justify-content: space-between
    }
  }

  .sub-title {
    text-align: left;
    margin-right: 1em;
  }

  .dropdown {
    position: relative;
    &__select {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 148px;
      height: 30px;
      line-height: 30px;
      border: solid 1px #f0f0f8;
      margin-left: 15px;
      cursor: pointer;
      text-align: left;
      padding-left: 12px;
      padding-right: 12px;

      &>span {
        // color: #9692a9;
      }
    }
    &__options {
      // position: absolute;
      z-index: 1;
      top: 120%;
      left: 15px;
      width: 148px;
      box-shadow: 0 0 0px 1px #f0f0f8;
      display: inline-block;
    }
    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      cursor: pointer;

      & > span:nth-child(1) {
        text-align: left;
        color: #9692a9;
      }
      &:hover, &.active {
        background-color: #f0f0f8;
      }
    }
  }

  .hr {
    margin-left: auto;
    margin-right: auto;
    margin-top: 12px;
    width: 224px;
    height: 1px;
    background-color: #f0f0f8;
    border-radius: 1px;
    box-shadow: 0 0 1px 0px #f0f0f8;
  }
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/zoomSetting.bg/zoomSetting.vue